import React from "react";
import { Link } from "react-router-dom"; 

export default function GameCategories() {
  return (
    <section className="relative ">
      <div className="relative z-10 grid grid-cols-1 gap-4 xl-custom:grid-cols-12 mx-auto max-w-6xl px-4 p-14 sm:px-6">

        <div className="w-full flex justify-center order-1 xl-custom:order-1 col-span-1 xl-custom:col-span-6">
          <img
            src="/uploads/Assets/Game_categories_image.webp"
            alt="asset1"
            className="w-full h-auto object-contain"
          />
        </div>
        
        <div className="w-full py-8 text-black text-left order-2 xl-custom:order-2 col-span-1 xl-custom:col-start-8 xl-custom:col-span-5 xl-custom:pl-12">
          <h2 className="font-uber text-[28px] font-bold leading-[36px] sm:text-[32px] sm:leading-[40px] xl-custom:text-[36px] xl-custom:leading-[44px]">Game Categories</h2>
          <p className="mt-2 text-current font-uber text-[16px] font-normal leading-[24px]">
            A diverse range of game-based experiences, each designed to entertain, engage, and amplify brand resonance.
          </p>
          <Link 
            to="/games" 
            className="mt-4 xl-custom:mt-8 px-6 py-2 bg-black text-white rounded active:bg-gray-700 active:text-white text-[16px] font-uber font-medium inline-block"
          >
            Explore More
          </Link>
        </div>
      </div>
    </section>
  );
}